module.exports = __webpack_public_path__ + "img/IVimana64_ua.2d348163.webp";